import raf             from 'raf';
import debounce        from 'lodash.debounce';
import Promise         from 'promise-polyfill';

const selector = '[data-js-timeline]';
const timeline = function(el, app) {

    const $el = $( el );
    const $progress = $el.find( '.Ge-Timeline-Progress-Bar' );
    let observer;
    let popupObserver;

    // This is how thich the borders are so we can offset the bar the correct amount
    let totalOffset;

    const init = function() {
        totalOffset = $progress.position().left * 2;
        watchProgress();
        setProgress();
        setupEvents();
    };

    const setupEvents = function setupEvents() {
        $el.on( 'click touchstart keypress', '.Ge-Timeline-Milestone', ( event ) => {
            const isKeyPressOtherThanEnter = event.type === 'keypress' && event.keyCode !== 13;
            if (isKeyPressOtherThanEnter) {
                return;
            } 

            event.preventDefault();

            handleClick( $( event.currentTarget ), event );
        } );
    };

    const handleClick = function handleClick( $toggleClicked, event ) {
        const $currentToggled = $el.find( '.Ge-Timeline-Milestone--toggled' );

        $currentToggled.removeClass( 'Ge-Timeline-Milestone--toggled' );

        if ( !$currentToggled.is( $toggleClicked ) ) {
            if ( $toggleClicked.data( 'popup' ) ) {
                const settings = {
                    event,
                    popupTarget: $toggleClicked.data( 'popup' ),
                    popupAnchor: $toggleClicked
                };
                app.trigger( 'popPop', settings );
                watchPopover( $toggleClicked );
            }

            $toggleClicked.addClass( 'Ge-Timeline-Milestone--toggled' );
        }
    }

    const watchPopover = function watchPopover( $milestoneClicked ) {
        // Ugly fix to detect when a popup is closed
        popupObserver = new MutationObserver( ( mutations ) => {
            if ( !mutations[ 0 ].target.classList.contains( 'Ge-Popup-Mask--active' ) ) {
                handleClick( $milestoneClicked );
                popupObserver.disconnect();
            }
        } );

        popupObserver.observe(
            $( '.Ge-Popup-Mask' ).get( 0 ),
            {
                attributes: true,
                attributeFilter: [ 'class' ]
            }
        );
    };

    const watchProgress = function watchProgress() {
        observer = new MutationObserver( ( mutations ) => {
            setProgress();
        } );

        observer.observe(
            $progress.get( 0 ),
            {
                attributes: true,
                attributeFilter: [ 'data-progress' ]
            }
        );
    };

    const setProgress = function setProgress() {
        const currentWidth = Math.max( Math.min( Number( $progress.attr( 'data-progress' ) ), 100 ), 0 );
        const currentOffset = Math.floor( totalOffset / 100 * currentWidth );
        $progress.css( {
            width: `calc( ${ currentWidth }% - ${ currentOffset }px )`,
        } );
    };

    return {
        init: init()
    };
};

timeline.selector = selector;

export default timeline;
